var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Logout/Large/Gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0156444444 0.402589907 7.8584 0.402589907 7.8584 12 0.0156444444 12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logout/Large/Gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77368889,2.3631 C1.37475556,2.4481 1.08533333,2.8121 1.08533333,3.2291 L1.08533333,9.2141 C1.08533333,9.6341 1.37768889,10.0001 1.78151111,10.0821 L5.7552,10.8881 C6.0104,10.9401 6.27146667,10.8741 6.47288889,10.7051 C6.67333333,10.5361 6.78871111,10.2871 6.78871111,10.0211 L6.78871111,2.3821 C6.78871111,2.1141 6.67235556,1.8641 6.46897778,1.6951 C6.26657778,1.5271 6.00355556,1.4611 5.74737778,1.5151 L1.77368889,2.3631 Z M5.54693333,11.9621 L1.57324444,11.1541 C0.670755556,10.9711 0.0156444444,10.1551 0.0156444444,9.2141 L0.0156444444,3.2291 C0.0156444444,2.2971 0.662933333,1.4831 1.55564444,1.2921 L5.52835556,0.4451 C6.10133333,0.3221 6.69093333,0.4691 7.14462222,0.8461 C7.59831111,1.2241 7.8584,1.7831 7.8584,2.3821 L7.8584,10.0211 C7.8584,10.6151 7.60026667,11.1731 7.15146667,11.5511 C6.80142222,11.8431 6.37022222,12.0001 5.92631111,12.0001 C5.80017778,12.0001 5.67306667,11.9871 5.54693333,11.9621 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.5863379 L9,7.29103854 C9,7.10574339 8.88134431,6.96874325 8.75651578,7.00619652 L8.40740741,7.11067145 C8.17009602,7.18163555 8,7.48224737 8,7.83115421 L8,12.75626 C8,12.9110012 8.09876543,13.0263179 8.20438957,12.9947783 C8.66803841,12.8548213 9,12.2673962 9,11.5863379 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47405376,6.88692703 C5.47405376,5.84792465 6.19978058,4.95082994 7.2118486,4.73846461 L8.67317608,4.4328173 C8.8627537,4.39312284 9,4.2244214 9,4.02892621 L9,2.67832235 C9,1.98763881 8.51519473,1.39321434 7.84081185,1.25825319 L1.72397148,0.0287174164 C0.831376851,-0.150899996 0,0.534821729 0,1.44977894 L0,12.5513259 C0,13.4702525 0.841250686,14.157959 1.73680746,13.968418 L4.97542512,13.2856733 C5.26670324,13.2241469 5.47405376,12.9661329 5.47405376,12.6684245 L5.47405376,6.88692703 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorWhite);
export default __webpack_public_path__ + "static/media/mirror_white.00237414bc1e8f0aa4662b80ab9f23f2.svg";
export { ForwardRef as ReactComponent };